import { fetchLanguageStrings } from '../../api';
import { handleError } from '../actionHelpers';

export default locale => (dispatch, getState) => {
  const needMessages = !Object.keys(getState().locales.messages).includes(
    locale
  );
  if (needMessages) {
    return fetchLanguageStrings(locale).then(
      messages => {
        dispatch({
          type: 'ADD_MESSAGES_FOR_LOCALE',
          locale,
          messages,
        });
        dispatch({
          type: 'CHANGE_LOCALE',
          locale,
        });
      },
      error => handleError(dispatch, error, 'FETCH_MESSAGE_STRINGS_FAILURE')
    );
  }
  return dispatch({
    type: 'CHANGE_LOCALE',
    locale,
  });
};
